export function fireLoadedEvent() {
  setTimeout(() => {
    const event = new CustomEvent('vaReportComponents.loaded');
    dispatchEvent(event);
  }, 0);
}
